/**
 * Main page implementation.
 */

'use strict';

var app                     = require('mag-app'),
    keys                    = require('stb-keys'),
    Page                    = require('stb-component-page'),
    Panel                   = require('mag-component-panel'),
    PanelSet                = require('mag-component-panel-set'),
    LayoutList              = require('mag-component-layout-list'),
    ModalMessage            = require('mag-component-modal'),
    RadioList               = require('mag-component-radio-list'),
    ScrollBar               = require('stb-component-scrollbar'),
    Footer                  = require('mag-component-footer'),

    appExit                 = require('../modules/app.exit'),
    keyboard                = require('../modules/keyboard'),
    div                     = require('../modules/div'),

    page                    = new Page({$node: window.pageMain}),
    stationTitle            = document.getElementById('pageMainSongTitle'),
    trackListScrollBar      = new ScrollBar(),
    intentContext           = null,
    // list of songs fetched originally
    initialStationsListData = [],
    // list of songs filtered/searched by user
    searchResultData        = [],
    currentIndex,
    trackList,
    mainPanel,
    panelSet,
    timerId,

    $headerAmount,
    $iconSearch,
    $inputSearch,
    $favoritesMenuItem;


/**
 * Write data to appropriate fields in the title bar of main page.
 *
 * @param {number} index - index of current track
 * @param {string} name - name of current track
 */
function setPageMainSongTitle ( index, name ) {
    stationTitle.firstElementChild.innerText = index;
    stationTitle.lastElementChild.innerText = name;
}


/**
 * Play track with intents.
 *
 * @param {Object} item - item to play
 * @param {number} trackIndex - index of item to go to
 */
function playSong ( item, trackIndex ) {
    var queue        = searchResultData,
        intentConfig = {
            action: 'play',
            mime: 'content/video',
            data: {
                uri:      item.url,
                title:    item.name,
                solution: item.solution,
                mediaId:  item.id
            },
            context: intentContext,
            events: {
                error: function () { /* action */ },
                close: function () {
                    intentContext = null;
                    trackList.focusIndex(currentIndex = queue.next || trackIndex - 1);
                    queue.next = undefined;
                },
                prev: function () {
                    var next = queue.next;

                    if ( next === undefined ) {
                        next = queue.next = queue.indexOf(item) - 1;
                    } else {
                        next = queue.next = next - 1;
                    }

                    // cycle
                    if ( next < 0 ) {
                        next = queue.length - 1;
                    }

                    if ( queue[queue.next].url ) {
                        playSong(queue[queue.next], queue.next + 1);
                    } else {
                        app.karaokeBackend.getPlaybackLink(queue[queue.next].id, function ( error, data ) {
                            var index, dataLength;

                            for ( index = 0, dataLength = initialStationsListData.length; index < dataLength; index += 1 ) {
                                if ( initialStationsListData[index].id === queue[queue.next].id ) {
                                    initialStationsListData[index].url = data.url;
                                    break;
                                }
                            }

                            queue[queue.next].url = data.url;
                            playSong(queue[queue.next], queue.next + 1);
                        });
                    }
                },
                next: function () {
                    var next = queue.next;

                    if ( next === undefined ) {
                        next = queue.next = queue.indexOf(item) + 1;
                    } else {
                        next = queue.next = next + 1;
                    }

                    // cycle
                    if ( next === queue.length ) {
                        next = 0;
                    }

                    if ( queue[queue.next].url ) {
                        playSong(queue[queue.next], queue.next + 1);
                    } else {
                        app.karaokeBackend.getPlaybackLink(queue[queue.next].id, function ( error, data ) {
                            var index, dataLength;

                            for ( index = 0, dataLength = initialStationsListData.length; index < dataLength; index += 1 ) {
                                if ( initialStationsListData[index].id === queue[queue.next].id ) {
                                    initialStationsListData[index].url = data.url;
                                    break;
                                }
                            }

                            queue[queue.next].url = data.url;
                            playSong(queue[queue.next], queue.next + 1);
                        });
                    }
                }
            }
        };

    // delete intent events depending on file position in queue
    // disable "prev" on the first one and "next" on the last
    if ( queue[0].id === item.id ) {
        delete intentConfig.events.prev;
    }

    if ( queue[queue.length - 1].id === item.id ) {
        delete intentConfig.events.next;
    }

    core.intent(intentConfig, function ( error, context ) {
        if ( !error ) {
            intentContext = context;
        }
    });

    setPageMainSongTitle(trackIndex, item.name);
}


/**
 * Construct appropriate render structure for lists from raw sources.
 *
 * @param {Object[]} stations - array of radio stations
 *
 * @return {Object[]} array of ready-to-use in LayoutList objects
 */
function constructDataOut ( stations ) {
    stations = stations.map(function ( station, stationIndex ) {
        return {
            items: [
                {
                    value: '' + ++stationIndex,
                    className: 'trackNumber'
                },
                {
                    value: station.performer,
                    className: 'songPerformerListBlock'
                },
                {
                    value: station.name,
                    className: 'songNameListBlock'
                },
                {
                    name: '$favorites',
                    value: '',
                    className: 'favoritesBlock theme-icon ' + (station.favorite ? 'theme-icon-favorite-active active' : '')
                }
            ],
            value: {
                id: station.id,
                isFavorite: station.favorite
            },
            click: function () {
                if ( station.url ) {
                    playSong(station, stationIndex);
                } else {
                    app.karaokeBackend.getPlaybackLink(station.id, function ( error, data ) {
                        var index, dataLength;

                        for ( index = 0, dataLength = initialStationsListData.length; index < dataLength; index += 1 ) {
                            if ( initialStationsListData[index].id === station.id ) {
                                initialStationsListData[index].url = data.url;
                                break;
                            }
                        }

                        station.url = data.url;
                        playSong(station, stationIndex);
                    });
                }

                setPageMainSongTitle(stationIndex, station.name);
            }
        };
    });

    return stations;
}


/**
 * Sorting songs.
 *
 * @param {string} base - sorting type
 *
 * @return {Object[]} array of stations
 */
function karaokeSort ( base ) {
    var stations;

    initialStationsListData = initialStationsListData || [];

    if ( !searchResultData || !searchResultData.length ) {
        return [];
    }

    stations = searchResultData;

    switch ( base ) {
        case 'PERFORMER':
            stations.sort(function ( arg1, arg2 ) {
                return arg1.performer.toLowerCase().localeCompare(arg2.performer.toLowerCase());
            });
            break;
        case 'NAME':
            stations.sort(function ( arg1, arg2 ) {
                return arg1.name.toLowerCase().localeCompare(arg2.name.toLowerCase());
            });
            break;
        case 'DATE':
            stations.sort(function ( arg1, arg2 ) {
                return arg1.id - arg2.id;
            });
            break;
    }

    return stations;
}


/**
 * Render list of karaoke tracks.
 *
 * @param {Array} data - tracks to render in a list
 */
function renderTrackList ( data ) {
    if ( trackList ) {
        trackList.setData({
            data:       data,
            focusIndex: currentIndex || 0
        });

        $headerAmount.innerText = data.length;
    } else {
        trackList = new LayoutList({
            data:       data,
            size:       7,
            scroll:     trackListScrollBar,
            focusIndex: 0,
            cycle:      true,
            propagate:  true,
            noData:     gettext('No songs')
        });
    }
}


/**
 * Send request to API to refresh data list.
 *
 * @param {Object} [query] - query parameters set
 */
function refreshList ( query ) {
    if ( !query ) {
        query = {search: app.state.SEARCH};
    }

    app.karaokeBackend.getTracks(query, function ( error, data ) {
        if ( error ) {
            data = [];
        }

        setTimeout(function () {
            initialStationsListData = data;
            searchResultData = initialStationsListData.slice();
            renderTrackList(constructDataOut(karaokeSort(app.state.SORT)));
        }, 0);
    });
}


/**
 * Search at karaoke tracks.
 *
 * @param {string} request - search request
 */
function karaokeSearch ( request ) {
    if ( request ) {
        app.karaokeBackend.getTracks({search: request}, function ( error, data ) {
            initialStationsListData = data;
            searchResultData = initialStationsListData.slice();
            $iconSearch.classList.add('active');
            renderTrackList(constructDataOut(karaokeSort(app.state.SORT)));
        });
        app.flags.isStationsListInitial = false;
        app.flags.isSearched = true;
    } else {
        if ( !app.flags.isStationsListInitial ) {
            refreshList({
                favorite: app.flags.isFavoritesShown,
                search:   app.state.SEARCH
            });
            app.flags.isStationsListInitial = true;
            $iconSearch.classList.remove('active');
        }
        app.flags.isSearched = false;
    }
}


/** Switch between active and inactive favorites states. */
function toggleFavorites () {
    var target     = trackList.$focusItem,
        value      = target.data.value,
        isFavorite = value.isFavorite;

    app.karaokeBackend.setFavoriteState(value.id, !isFavorite, function () {
        var favoritesBlock = target.layout.links.$favorites,
            index, length;

        target.data.value.isFavorite = !isFavorite;
        favoritesBlock.className =
            trackList.data[trackList.$focusItem.index].items[3].className =
                'favoritesBlock theme-icon' + (isFavorite ? '' : ' theme-icon-favorite-active active');

        // synchronize data
        for ( index = 0, length = searchResultData.length; index < length; index += 1 ) {
            if ( searchResultData[index].id === value.id ) {
                searchResultData[index].favorite = !isFavorite;
                break;
            }
        }
    });
}


/** Helper function for closing modal window. */
function closeModalWindow () {
    page.modalContextMenu.hide();
    page.modalSorting.hide();
    page.modalResetFilters.hide();
    app.flags.isModalShown = false;
    panelSet.focus();
    page.footer.show();
}


/**
 * Initialize UI components.
 *
 * @param {Array} data - tracks to render in a list
 */
// eslint-disable-next-line
function init ( data ) {
    var $menuSortingItem,
        leftPanel,
        leftPanelFooterConfig,
        mainPanelFooterConfig;

    /** Reset user filters in the menu panel. */
    function resetFilters () {
        app.flags.isStationsListInitial = true;
        app.flags.isFavoritesShown = false;
        app.state.SORT = 'NUMBER';
        app.state.SEARCH = '';
        $menuSortingItem.innerText = gettext('By number');
        $favoritesMenuItem.className = 'theme-icon theme-icon-favorite';
        $iconSearch.classList.remove('active');
        $inputSearch.innerText = gettext('Search');
        refreshList();
    }

    leftPanelFooterConfig = {
        left: {
            code: keys.menu,
            action: function () {
                page.modalResetFilters.show();
            }
        },
        middle: [{code: keys.f1, title: gettext('Reset filters'), action: resetFilters}]
    };

    mainPanelFooterConfig = {
        left: {
            code: keys.menu,
            action: function () {
                page.modalContextMenu.show();
            }
        },
        middle: [
            {
                code: keys.f3,
                title: gettext('Favorites'),
                action: toggleFavorites
            },
            {
                code: keys.f4,
                title: gettext('Search'),
                action: function () {
                    leftPanel.focus();

                    keyboard.open({
                        title: gettext('SONG SEARCH'),
                        input: $inputSearch,
                        value: app.state.SEARCH
                    }, function ( event ) {
                        karaokeSearch(app.state.SEARCH = event.value);
                    });
                }
            }
        ]
    };

    page.footer = new Footer({
        parent: page,
        data: [],
        visible: true
    });

    page.modalSorting = new ModalMessage({
        parent: page,
        title: gettext('sorting'),
        events: {
            show: function () {
                this.focus();
                panelSet.blur();
                app.flags.isModalShown = true;
                page.footer.hide();
            },
            hide: closeModalWindow
        },
        children: [
            new RadioList({
                focusIndex: 0,
                size: 3,
                cycle: true,
                events: {
                    'click:item': function ( event ) {
                        page.modalSorting.hide();
                        renderTrackList(
                            constructDataOut(
                                // eslint-disable-next-line
                                karaokeSort(app.state.SORT = event.$item.value ? (event.$item.value === 1 ? 'NAME' : 'DATE') : 'PERFORMER')
                            )
                        );
                        $menuSortingItem.innerText = event.$item.data.title;
                    }
                },
                data: [
                    {
                        state: app.state.SORT === 'PERFORMER',
                        title: gettext('By performer'),
                        value: 0
                    },
                    {
                        state: app.state.SORT === 'NAME' || !app.state.SORT,
                        title: gettext('By name'),
                        value: 1
                    },
                    {
                        state: app.state.SORT === 'DATE',
                        title: gettext('By date'),
                        value: 2
                    }
                ]
            })
        ]
    });

    page.modalResetFilters = new ModalMessage({
        parent: page,
        title: gettext('actions'),
        events: {
            show: function () {
                this.focus();
                panelSet.blur();
                app.flags.isModalShown = true;
                page.footer.hide();
            },
            hide: closeModalWindow
        },
        children: [
            new LayoutList({
                size: 1,
                focusIndex: 0,
                data: [
                    {
                        items: [
                            {
                                className: 'theme-icon theme-icon-rc-f1'
                            },
                            gettext('Reset filters')
                        ],
                        click: function () {
                            resetFilters();
                            closeModalWindow();
                        }
                    }
                ],
                events: {
                    keydown: function ( event ) {
                        LayoutList.prototype.defaultEvents.keydown.call(this, event);
                        if ( event.code === keys.menu ) {
                            event.stop = true;
                            closeModalWindow();
                        }
                    }
                }
            })
        ]
    });

    page.modalContextMenu = new ModalMessage({
        parent: page,
        title: gettext('actions'),
        events: {
            show: function () {
                this.focus();
                panelSet.blur();
                app.flags.isModalShown = true;
                page.footer.hide();
            },
            hide: closeModalWindow
        },
        children: [
            new LayoutList({
                size: 1,
                focusIndex: 0,
                data: [
                    {
                        items: [
                            {
                                value: '',
                                className: 'theme-icon theme-icon-rc-f3'
                            },
                            gettext('Favorites')
                        ],
                        click: function () {
                            toggleFavorites();
                            closeModalWindow();
                        }
                    }
                ],
                events: {
                    keydown: function ( event ) {
                        LayoutList.prototype.defaultEvents.keydown.call(this, event);

                        if ( event.code === keys.menu ) {
                            event.stop = true;
                            closeModalWindow();
                        }
                    }
                }
            })
        ]
    });

    page.footer.init();
    renderTrackList(data);

    page.add(
        panelSet = new PanelSet({
            panels: [
                leftPanel = new Panel({
                    size: 1,
                    title: gettext('menu'),
                    children: [
                        new LayoutList({
                            cycle: true,
                            propagate: true,
                            size: 4,
                            focusIndex: 0,
                            data: [
                                {
                                    items: [
                                        $iconSearch  = div('theme-icon theme-icon-search' + (app.state.SEARCH ? ' active' : '')),
                                        $inputSearch = div('inputSearch', app.state.SEARCH || gettext('Search'))
                                    ],
                                    value: {
                                        defaultValue: gettext('Search')
                                    },
                                    click: function () {
                                        keyboard.open({
                                            title: gettext('SONG SEARCH'),
                                            input: $inputSearch,
                                            value: app.state.SEARCH
                                        }, function ( event ) {
                                            karaokeSearch(app.state.SEARCH = event.value);
                                        });
                                    }
                                },
                                {
                                    items: [
                                        $favoritesMenuItem = div('theme-icon theme-icon-favorite'),
                                        gettext('Favorites')
                                    ],
                                    click: function () {
                                        var menuItemClassList = $favoritesMenuItem.classList;

                                        refreshList({
                                            favorite: app.flags.isFavoritesShown = !app.flags.isFavoritesShown,
                                            search:   app.state.SEARCH
                                        });

                                        menuItemClassList.toggle('theme-icon-favorite');
                                        menuItemClassList.toggle('theme-icon-favorite-active');
                                        menuItemClassList.toggle('active');
                                    }
                                },
                                {
                                    items: [
                                        {
                                            className: 'theme-icon theme-icon-sort-az'
                                        },
                                        $menuSortingItem = div(
                                            'theme-item-more',
                                            app.state.SORT === 'PERFORMER'
                                                ? gettext('By performer')
                                                : app.state.SORT === 'DATE' ? gettext('By date') : gettext('By name')
                                        )
                                    ],
                                    click: function () {
                                        panelSet.blur();
                                        page.modalSorting.show();
                                    }
                                },
                                {
                                    items: [
                                        {
                                            value: '',
                                            className: 'theme-icon theme-icon-exit'
                                        },
                                        {
                                            value: gettext('Exit'),
                                            className: ''
                                        }
                                    ],
                                    click: function () {
                                        app.state.PANEL_POS = panelSet.focusIndex;
                                        app.state.DISPLAY_FAV = app.flags.isFavoritesShown;
                                        panelSet.blur();
                                        appExit.goExit();
                                    }
                                }
                            ]
                        })
                    ]
                }),
                mainPanel = new Panel({
                    size: 2,
                    title: [
                        {
                            value: gettext('songs'),
                            className: 'name'
                        },
                        div('amountContainer', $headerAmount = div('amount', data.length))
                    ],
                    main: true,
                    children: [trackList]
                })
            ]
        })
    );

    app.mainPanelSet = panelSet;

    leftPanel.addListener('focus', function () {
        page.footer.init(leftPanelFooterConfig);
    });

    mainPanel.addListener('focus', function () {
        page.footer.init(mainPanelFooterConfig);
    });

    mainPanel.add(trackListScrollBar);
    panelSet.panels[app.state.PANEL_POS === '' ? 1 : app.state.PANEL_POS].focus();
}


app.flags = {
    isModalShown: false,
    isSearched: !!app.state.SEARCH,
    isFavoritesShown: app.state.DISPLAY_FAV = !!app.state.DISPLAY_FAV,
    // flag to detect is full list of received stations displayed
    isStationsListInitial: searchResultData.length === initialStationsListData.length
};

page.addListeners({
    show: function ( event ) {
        if ( event.data.length ) {
            initialStationsListData = event.data;
            searchResultData = initialStationsListData.slice();
            init(constructDataOut(karaokeSort(app.state.SORT || 'NAME')));
        } else {
            init([]);
        }

        if ( app.state.SEARCH ) {
            $iconSearch.classList.add('active');
        }

        if ( app.state.DISPLAY_FAV ) {
            $favoritesMenuItem.classList.remove('theme-icon-favorite');
            $favoritesMenuItem.classList.add('theme-icon-favorite-active', 'active');
        }
    },
    keydown: function ( event ) {
        if ( event.code === keys.back ) {
            if ( app.flags.isModalShown ) {
                closeModalWindow();
            } else {
                app.state.PANEL_POS = panelSet.focusIndex;
                app.state.DISPLAY_FAV = app.flags.isFavoritesShown;
                appExit.goBack();
            }
        }
    }
});

core.addListeners({
    show: function () {
        if ( app.flags.isSearched || app.flags.isFavoritesShown ) {
            return;
        }

        if ( page.loaded ) {
            refreshList();
            timerId = setInterval(refreshList, 24 * 60 * 60 * 1000);
        }

        page.loaded = true;
    },
    hide: function () {
        clearInterval(timerId);
    }
});


module.exports = page;
